'use client';

import { useTranslation } from '@root/src/i18n/client';

interface CategoryQuickNavItem {
  id: string;
  name: string;
}

interface CategoryQuickNavProps {
  categories: CategoryQuickNavItem[];
}

export default function CategoryQuickNav({
  categories,
}: CategoryQuickNavProps) {
  const { t } = useTranslation('common');

  const handleScrollToCategory = (id: string) => {
    const element = document.getElementById(`category-section-${id}`);

    if (!element) return;

    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  if (categories.length === 0) return null;

  return (
    <div className="sticky top-3 z-20 mb-6 rounded-2xl border border-[#E7DECF] bg-[#FBF7F0]/95 p-3 shadow-[0_10px_30px_rgba(34,58,39,0.08)] backdrop-blur md:mb-8 md:p-4">
      <div className="mb-3 flex items-center gap-2 px-1">
        <div className="h-2 w-2 rounded-full bg-[#223A27]" />
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#6B6656]">
          {t('lytra.quickCategory')}
        </p>
      </div>

      <div className="flex gap-2 overflow-x-auto pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {categories.map(category => (
          <button
            key={category.id}
            type="button"
            onClick={() => handleScrollToCategory(category.id)}
            className="shrink-0 rounded-full border border-[#DED4C3] bg-white px-4 py-2 text-sm font-medium text-[#223A27] transition-colors duration-200 hover:border-[#223A27] hover:bg-[#223A27] hover:text-white"
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
}
